import axiosInstance from "./axiosInstance";

export const createRawMaterialUsage = async ({ raw_material_id, qty_used, reason = "" }) => {
  const res = await axiosInstance.post("/pos/raw-material-usage", { raw_material_id, qty_used, reason });
  return res.data;
};

export const fetchRawMaterialUsageLogs = async ({
  page = 1,
  limit = 10,
  search = "",
  startDate = "",
  endDate = "",
  branchId = "",
} = {}) => {
  const res = await axiosInstance.get("/pos/raw-material-usage", {
    params: { page, limit, search, startDate, endDate, branch_id: branchId || undefined },
  });
  return res.data;
};
